import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Form, Modal, Input, message, Select, Switch  } from 'antd';
import { EQUIPMENT_QR } from '../constants';

import { updateEquipmentDetails } from '../actions/equipmentActions';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

class EditEquipmentModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false
        }
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.onCancel();
    }

    handleOk = () => {
        const { form } = this.props;
        form.validateFields(async (err, values) => {
            if (err) {
                return;
            }
            await this.setState({ savingChanges: true });
            message.loading('Saving changes...', 0);
            const equipmentInfo = {
                productName: values.productName,
                manufacturer: values.manufacturer,
                modelNo: values.modelNo,
                serialRange: values.serialRange,
                competencyTimeFrame: values.competencyTimeFrame,
                qrStatus: values.qrStatus ? EQUIPMENT_QR.ENABLED : EQUIPMENT_QR.DISABLED
            }

            const result = await updateEquipmentDetails(this.props.equipmentInfo.equipment_id, equipmentInfo);
            message.destroy();
            if(result){
                message.success('Equipment details updated successfully');
                form.resetFields();
                this.props.onSave();
            }else{
                message.error("Error in updating equipment details");
                await this.setState({ savingChanges: false });
            }
        });
    }

    render() {
        const { form, equipmentInfo } = this.props;
        const { getFieldDecorator } = form;

        return (
            <Modal
                title={"Edit Equipment Details"}
                visible={this.props.visible}
                okText={"Save"}
                cancelText={"Cancel"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                destroyOnClose={true}
                okButtonProps={{ disabled: this.state.savingChanges }}
                cancelButtonProps={{ disabled: this.state.savingChanges }}
            >
                <Form layout='horizontal'>
                    <FormItem {...formItemLayout} label={"Model"}>
                        {
                            getFieldDecorator('productName', { initialValue: equipmentInfo.name, rules: [{ required: true, message: 'Please enter model' }] })(
                                <Input maxLength={100} placeholder={"Enter model"} />
                            )
                        }
                    </FormItem>
                    <FormItem {...formItemLayout} label={"Manufacturer"}>
                        {
                            getFieldDecorator('manufacturer', { initialValue: equipmentInfo.manufacturer_name, rules: [{ required: true, message: 'Please enter manufacturer' }] })(
                                <Input maxLength={100} placeholder={"Enter manufacturer"} />
                            )
                        }
                    </FormItem>
                    <FormItem {...formItemLayout} label={"Model Number"}>
                        {
                            getFieldDecorator('modelNo', { initialValue: equipmentInfo.model_no, rules: [{ required: true, message: 'Please enter model number' }] })(
                                <Input maxLength={100} placeholder={"Enter model number"} />
                            )
                        }
                    </FormItem>
                    <FormItem {...formItemLayout} label={"Serial Range"}>
                        {
                            getFieldDecorator('serialRange', { initialValue: equipmentInfo.serial_no })(
                                <Input maxLength={100} placeholder={"Enter serial range"} />
                            )
                        }
                    </FormItem>
                    <FormItem {...formItemLayout} label={"Competency Timeframe"}>
                        {
                            getFieldDecorator('competencyTimeFrame', { initialValue: equipmentInfo.competency_timeframe })(
                                <Select>
                                    <Option value={null} >N/A</Option>
                                    <Option value="ONE_YEAR">One year</Option>
                                    <Option value="TWO_YEARS">Two years</Option>
                                    <Option value="THREE_YEARS">Three years</Option>
                                    <Option value="FOUR_YEARS">Four years</Option>
                                    <Option value="FIVE_YEARS">Five years</Option>
                                </Select>
                            )
                        }
                    </FormItem>
                    <Form.Item {...formItemLayout}  label={"QR Code"}>
                        {
                            getFieldDecorator('qrStatus',{ initialValue: equipmentInfo.qr_code_status === EQUIPMENT_QR.ENABLED ? true : false} )(
                                <Switch checkedChildren="Enabled" unCheckedChildren="Disabled" defaultChecked = {equipmentInfo.qr_code_status === EQUIPMENT_QR.ENABLED ? true : false}/>
                            )
                        }
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

function mapStateToProps(state, props) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditEquipmentModal));